export const loginScreenSelector = ({auth: {loginScreen} = {}}) => loginScreen;
export const authSelector = ({auth: {auth} = {}}) => auth;
export const tokenSelector = ({auth: {auth: {token} = {}} = {}}) => token;
export const userSelector = ({auth: {auth: {user} = {}} = {}}) => user;
export const forgotPasswordSelector = ({auth: {forgotPassword} = {}}) =>
  forgotPassword;
